import { getIntegrationManifests } from '@gonfalon/openapi/operations/getIntegrationManifests';

import { createQueryOptions } from '../internal/createQueryOptions';

export const getIntegrationManifestsQuery = createQueryOptions(getIntegrationManifests);
